import { Button } from "../../components/Button";
import { Card } from "../../components/Card";
import { PersonalDataConsent } from "../../components/PersonalDataConsent";
import { PROMO_EACH } from "./constants";

export function PromotionsProfilePromoCard({
  lastName,
  setLastName,
  firstName,
  setFirstName,
  patronymic,
  setPatronymic,
  nickname,
  setNickname,
  err,
  ok,
  submitting,
  onSubmit,
  onOpenPrivacyPolicy,
}) {
  return (
    <Card
      variant="light"
      className="promotionsPromoCard"
      title={`Заполните ФИО и ник — ${PROMO_EACH} бонусов`}
      subtitle="Одноразовая акция: после отправки форма скроется."
    >
      <form className="promotionsPromoCard__form" onSubmit={onSubmit}>
        <PersonalDataConsent
          consentId="promo-pd-consent-profile"
          onOpenPrivacyPolicy={onOpenPrivacyPolicy}
        />
        <label className="field">
          Фамилия
          <input
            type="text"
            autoComplete="family-name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </label>
        <label className="field">
          Имя
          <input
            type="text"
            autoComplete="given-name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </label>
        <label className="field">
          Отчество
          <input
            type="text"
            autoComplete="additional-name"
            value={patronymic}
            onChange={(e) => setPatronymic(e.target.value)}
            required
          />
        </label>
        <label className="field">
          Ник (необязательно)
          <input
            type="text"
            placeholder="@username или псевдоним"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
        </label>
        {err ? <p className="errorMessage">{err}</p> : null}
        {ok ? <p className="successMessage">{ok}</p> : null}
        <Button type="submit" variant="accent" disabled={submitting}>
          {submitting ? "Отправка…" : `Получить ${PROMO_EACH} бонусов`}
        </Button>
      </form>
    </Card>
  );
}
